<template>
    <div class="layout-wrapper">
        <div class="container-fluid">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header  bg-accent-grad glow-accent text-center">
                        <h3 class="text-white">مدیریت ثبت استعلام از تامین کننده</h3>

                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="card-header admin-header w-100">

                                <h5 class="text-accent-light">لیست استعلام های در حال ثبت</h5>
                                <!--<h5 class="text-accent-light" v-if="showReciveDate">(سر رسید تاریخ)</h5>-->
                                <h5 class="text-accent-light" v-if="showArchive">(آرشیو شده)</h5>
                                <div class="text-left">
                                    <button class="btn btn-link text-accent-lightt"
                                            @click="onMyRegistrationRecordClicked()">
                                        <i class="fa fa-eye" v-if="showMyRegister" title="نمایش تمام استعلام ها"></i>
                                        <i class="fa fa-eye-slash" v-else title="نمایش استعلام های خودم"></i>
                                    </button>
                                    <button class="btn btn-link text-accent-lightt"
                                            @click="onArchiveClicked()">
                                        <i class="fa fa-eye" v-if="showArchive" title="عدم نمایش آرشیو ها"></i>
                                        <i class="fa fa-eye-slash" v-else title="نمایش آرشیو ها"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="col-12 input-group round mb-3" v-if="!showArchive">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">جستجو</span>
                                </div>
                                <input class="form-control" v-model="search" @input="searching()"
                                       placeholder="حداقل 2 کاراکتر از نام سازمان  را وارد کنید">
                            </div>
                            <!--///////// FILTERS  /////////////////-->


                            <!--///////// FILTERS  /////////////////-->


                            <div class="table-responsive">
                                <div v-if="!isLoading">
                                    <preloader/>
                                </div>
                                <div v-else>
                                    <div v-if="inquirisList.length===0">
                                        <p class="text-center mt-3">هیچ نیاز/استعلامی ثبت نشده است. برای ثبت روی دکمه +
                                            کلیک
                                            کنید</p>

                                    </div>
                                    <div v-else>
                                        <table class="table table-hover table-striped mb-3">
                                            <thead>
                                            <tr>
                                                <th>شماره نیاز</th>
                                                <th>تاریخ نیاز</th>
                                                <th>نام مشتری</th>
                                                <th>وضعیت استعلام</th>
                                                <th>تاریخ اتمام</th>
                                                <th>ساعت اتمام</th>
                                                <th class="text-center">عملیات</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="it in inquirisList" v-if="inquirisList.length>0">
                                                <td class="text-nowrap">{{it.inquirynumber}}</td>
                                                <td class="text-nowrap">{{showDateDayWork(it.startDate)}}</td>
                                                <td class="text-wrap">{{it.customerFullName}}</td>
                                                <td class="text-nowrap">{{showstatussupplierinquiry(it.inquiryStatus)}}</td>
                                                <td class="text-nowrap">{{showDateDayWork(it.expiryDate)}}</td>
                                                <td class="text-nowrap">{{showExpiryHour(it.expiryHour)}}</td>
                                                <td class="text-center text-nowrap"><i
                                                        class="fa fa-pencil-square-o px-3 clickable"
                                                        style="font-size: larger"
                                                        @click="editInquiriItem(it)"
                                                        title="ویرایش آیتم"></i>

                                                </td>

                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////-->
            <modal show="false" ref="insertModal" v-if="showinquiry">
                <div class="row p-3">
                    <div class="col-12 text-center">
                        <h2> ثبت قیمت استعلام از تامین کننده</h2>
                        <div class="row p-1">
                            <h3>مشخصات استعلام</h3>
                        </div>
                    </div>

                    <!--<hr class="w-100"/>-->
                    <!--<h5 class="col-12 text-center"> نام سازمان/مشتری انتخاب شده</h5>-->
                    <div class="row w-100">
                        <div class="row mt-0">
                            <div class="col-lg-3 mb-1">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شماره نیاز</span>
                                    </div>
                                    <input class="form-control" readonly="true" v-model="inquiriModel.inquirynumber">
                                </div>
                            </div>

                            <div class="col-lg-3 mb-1">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">تاریخ نیاز</span>
                                    </div>
                                    <input type="text" class="form-control" readonly="true" v-model="this.inquirydate">
                                </div>
                            </div>

                            <!--<div class="col-lg-2 mb-1">-->
                            <!--<div class="input-group round">-->
                            <!--<div class="input-group-prepend">-->
                            <!--<span class="input-group-text">نوع نیاز</span>-->
                            <!--</div>-->
                            <!--<input type="text" class="form-control"  readonly="true"  v-model="this.selectedinquiritype">-->
                            <!--</div>-->
                            <!--</div>-->
                            <!--///////////////////////////////////////////-->
                            <!--////////////&lt;!&ndash;مشخصات استعلام &ndash;&gt;-->
                            <!--/////////////////////////////////////////////-->
                            <div class="col-lg-6 mb-1">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام مشتری/سازمان</span>
                                    </div>
                                    <input type="text" class="form-control" readonly="true"
                                           v-model="inquiriModel.customerFullName">
                                </div>
                            </div>

                            <div class="col-lg-3 mb-1">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">تاریخ شروع</span>
                                    </div>
                                    <input type="text" class="form-control" readonly="true"
                                           v-model="this.inquiryStartdate">
                                </div>
                            </div>

                            <div class="col-lg-2 mb-1">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">ساعت شروع</span>
                                    </div>
                                    <input type="text" class="form-control" readonly="true"
                                           v-model="displaystartHour">
                                </div>
                            </div>

                            <div class="col-lg-3 mb-1">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">تاریخ اتمام</span>
                                    </div>
                                    <input type="text" class="form-control" readonly="true"
                                           v-model="this.inquiryEnddate">
                                </div>
                            </div>

                            <div class="col-lg-2 mb-1">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">ساعت اتمام</span>
                                    </div>
                                    <input type="text" class="form-control" readonly="true"
                                           v-model="displayexpiryHour">
                                </div>
                            </div>

                            <div class="col-lg-2 mb-1">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">مدت تسویه</span>
                                    </div>
                                    <input type="number" class="form-control" readonly="true"
                                           v-model="inquiriModel.settlementPeriod">
                                </div>
                            </div>
                            <!--///////////////////////////////////////////-->
                            <!--////////////&lt;!&ndash;مشخصات استعلام &ndash;&gt;-->
                            <!--/////////////////////////////////////////////-->
                        </div>
                    </div>
                    <hr class="w-100"/>
                    <div class="row w-100 p-0">
                        <div class="card-header admin-header w-100">
                            <h4 class="col-12 text-center">تامین کنندگان
                                <button class="btn btn-link text-accent-light text-left"
                                        @click="onAddSupplierInquiriClicked()"><i class="fa fa-plus"></i>
                                </button>
                            </h4>
                        </div>
                        <div class="col-12 overflow-auto" style="max-height: 12rem;">
                            <table class="table table-hover table-striped mb-3">
                                <thead>
                                <tr>
                                    <th>کد تامین کننده</th>
                                    <th>نام تامین کننده</th>
                                    <th>شماره همراه</th>
                                    <th>قیمت پیشنهادی</th>

                                    <th class="text-center">عملیات</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="it in supplierinquiry" v-if="supplierinquiry.length>0">
                                    <td class="text-nowrap">{{it.customerCode}}</td>
                                    <td class="text-nowrap">{{it.customerFullName}}</td>
                                    <td class="text-nowrap">{{it.mobile}}</td>
                                    <td class="text-nowrap">{{(it.totalPrice).toLocaleString()}}</td>

                                    <td class="text-center text-nowrap"><i
                                            class="fa fa-pencil-square-o px-3 clickable"
                                            style="font-size: larger"
                                            @click="editSupplierInquiryItem(it)"
                                            title="ویرایش آیتم"></i>
                                        |  <i class="fa fa-eye px-3 clickable"
                                              style="font-size: larger"
                                              @click="showDataOnTable(it)"
                                              title="نمایش "></i>

                                        | <i class="fa fa-trash-o px-3 clickable"
                                             style="font-size: larger"
                                             @click="deleteItem(it)"
                                             title="حذف آیتم"></i>
                                    </td>

                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <h4 class="col-12 text-center"> کالاهای استعلام</h4>
                    <div class="col-12 overflow-auto" style="max-height: 12rem;">
                        <table class="table table-hover table-striped mb-3">
                            <thead>

                            <tr>
                                <th class="text-center text-nowrap">نام کالا</th>
                                <th class="text-center text-nowrap">واحد</th>
                                <th class="text-center text-nowrap">تعداد/وزن</th>
                                <th class="text-center text-nowrap">قیمت کالا</th>
                                <th class="text-center text-nowrap">جمع کل</th>
                                <th class="text-center text-nowrap">تخفیف</th>
                                <th class="text-center text-nowrap">مبلغ کل</th>
                                <th class="text-center text-nowrap">ارزش افزوده%</th>
                                <th class="text-center text-nowrap">مبلغ ارزش افزوده</th>
                                <th class="text-center text-nowrap">جمع نهایی</th>
                            </tr>

                            </thead>
                            <tbody>
                            <tr v-for="item in productPriceInquiry" v-if="item.productCount>0">

                                <td class="text-center text-nowrap">{{item.productName}}</td>
                                <td class="text-center text-nowrap">{{item.unitName}}</td>
                                <td class="text-center text-nowrap">{{item.productCount}}</td>
                                <td class="text-center text-nowrap">
                                    <span v-if="isNaN(item.buyPrice)" class="text-warning">0</span>
                                    <span v-else>{{(item.buyPrice).toLocaleString()}}</span>
                                <td class="text-center text-nowrap">
                                    <span v-if="isNaN(item.totalPrice)" class="text-warning">0</span>
                                    <span v-else>{{(item.totalPrice).toLocaleString()}}</span>
                                </td>
                                <td class="text-center text-nowrap">
                                    <span v-if="isNaN(item.discount)" class="text-warning">0</span>
                                    <span v-else>{{(item.discount).toLocaleString()}}</span>
                                </td>
                                <td class="text-center text-nowrap">
                                    <span v-if="isNaN(item.totalNetPrice)" class="text-warning">0</span>
                                    <span v-else>{{(item.totalNetPrice).toLocaleString()}}</span>
                                </td>
                                <td class="text-center text-nowrap">
                                    <span v-if="isNaN(item.vatshow)" class="text-warning">0</span>
                                    <span v-else>{{(item.vatshow).toLocaleString()}}</span>
                                </td>
                                <td class="text-center text-nowrap">
                                    <span v-if="isNaN(item.totalVat)" class="text-warning">0</span>
                                    <span v-else>{{(item.totalVat).toLocaleString()}}</span>
                                </td>
                                <td class="text-center text-nowrap">
                                    <span v-if="isNaN(item.totalPriceVat)" class="text-warning">0</span>
                                    <span v-else>{{(item.totalPriceVat).toLocaleString()}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="6"></td>
                            </tr>
                            <tr class="bg-total-discount mt-3">
                                <td colspan="1"></td>
                                <td class="text-right">
                                    <span>جمع کل : </span>
                                </td>
                                <td class="text-center">
                                    <!--<span>تعداد کل: </span>-->
                                    <span v-if="isNaN(sumproductcount)" class="text-warning">تعداد به درستی وارد نشده است!</span>
                                    <span v-else>{{this.sumproductcount}}</span>
                                </td>
                                <td class="text-center">
                                    <!--<span>قیمت : </span>-->
                                    <span v-if="isNaN(sumbuyprice)"
                                          class="text-warning">مبلغ به درستی وارد نشده است!</span>
                                    <span v-else>{{(this.sumbuyprice).toLocaleString()}}</span>
                                </td>
                                <td class="text-center">
                                    <!--<span>جمع قیمت : </span>-->
                                    <span v-if="isNaN(sumtotalprice)"
                                          class="text-warning">قیمت به درستی وارد نشده است!</span>
                                    <span v-else>{{(sumtotalprice).toLocaleString()}}</span>
                                </td>
                                <td class="text-center">
                                    <!--<span>جمع تخفیف : </span>-->
                                    <span v-if="isNaN((sumdiscount))"
                                          class="text-warning">تخفیف به درستی وارد نشده است!</span>
                                    <span v-else>{{(this.sumdiscount).toLocaleString()}}</span>
                                </td>
                                <td class="text-center">
                                    <!--<span>جمع بعد از تخفیف : </span>-->
                                    <span v-if="isNaN((sumtotalnetprice))"
                                          class="text-warning">قیمت پس از تخفیف به درستی وارد نشده است!</span>
                                    <span v-else>{{(this.sumtotalnetprice).toLocaleString()}}</span>
                                </td>
                                <td class="text-center">
                                    <!--<span>مالیات بر ارزش افزوده : </span>-->
                                    <span v-if="isNaN((sumVat))"
                                          class="text-warning">ارزش افزوده به درستی وارد نشده است!</span>
                                    <span v-else>{{(this.sumVat).toLocaleString()}}</span>
                                </td>
                                <td class="text-center">
                                    <!--<span>مالیات بر ارزش افزوده : </span>-->
                                    <span v-if="isNaN((sumtotalvat))"
                                          class="text-warning">ارزش افزوده به درستی وارد نشده است!</span>
                                    <span v-else>{{(this.sumtotalvat).toLocaleString()}}</span>
                                </td>
                                <td class="text-center">
                                    <!--<span>جمع کل استعلام : </span>-->
                                    <span v-if="isNaN((sumtotalpricevat))"
                                          class="text-warning">جمع کل به درستی وارد نشده است!</span>
                                    <span v-else>{{(this.sumtotalpricevat).toLocaleString()}}</span>
                                </td>
                            </tr>

                            </tbody>
                        </table>


                    </div>


                </div>
            </modal>
            <modal show="false" ref="insertModal" v-if="showsupplierinquiry">
                <div class="row p-1">
                    <hr class="w-100"/>
                    <div class="row w-100 p-3">
                        <h4 class="col-12 text-center">تامین کننده جدید</h4>
                        <div class="row mt-0">

                            <div class="col-lg-3 mb-2">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">تاریخ استعلام</span>
                                    </div>
                                    <date-picker type="date" format="jYYYY/jMM/jDD" @input="onCreateInquiryDatePicked"
                                                 :auto-submit="true"
                                                 ref="supplierInquiryDate" style="flex: 1">
                                        <slot>
                                            <input v-model="supplierInquiryDate"
                                                   class="form-control date-input flex-grow-1" readonly="true"
                                                   @click="toggleCreateInquiryDatePicker">
                                        </slot>
                                    </date-picker>
                                </div>
                            </div>

                            <div class="col-lg-3 mb-2">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">ساعت استعلام</span>
                                    </div>
                                    <input type="number" class="form-control"
                                           v-model="supplierInquiryList.supplierInquiryHour"
                                           @input="onChangesupplierInquiryTime">
                                </div>
                                <small class="text-center">{{this.displaysupplierInquiryHour}}</small>
                            </div>

                            <div class="col-lg-6 mb-1">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام تامین کننده</span>
                                    </div>

                                    <vs-select @onSearch="onDropDownFocused"
                                               @onSearchBlurred="onDropDownBlurred"
                                               ref="evidence"
                                               :data="suppliers"
                                               :mode="'create'"
                                               :selected-val="filtersupplier"
                                               :header="{multiple: false, label: 'fullName'}"
                                               aria-placeholder=""
                                               @onChange="onfilterSupplierChange"></vs-select>
                                    <button class="btn btn-link text-accent-light"
                                            @click="newAddCustomer()"><i class="fa fa-plus"></i>
                                    </button>
                                </div>

                            </div>

                            <div class="col-lg-6 mb-1">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">تلفن همراه</span>
                                    </div>
                                    <vs-select @onSearch="onDropDownFocused"
                                               @onSearchBlurred="onDropDownBlurred"
                                               ref="evidence"
                                               :data="tablecustomerphone"
                                               :mode="'create'"
                                               :selected-val="filtercustomerphone"
                                               :header="{multiple: false, label: 'showName'}"
                                               aria-placeholder=""
                                               @onChange="onfilterCustomerPhoneChange"></vs-select>

                                    <button class="btn btn-link text-accent-light"
                                            @click="onAddNewCustomerPhoneClicked()"><i class="fa fa-plus"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="col-lg-3 mb-1">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">کد/شناسه ملی</span>
                                    </div>
                                    <input type="number" class="form-control" readonly="true"
                                           v-model="supplierInquiryList.nationalCode"
                                           @input="onChangesettlement">
                                </div>
                            </div>

                            <div class="col-lg-3 mb-1">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نحوه حمل</span>
                                    </div>
                                    <vs-select @onSearch="onDropDownFocused"
                                               @onSearchBlurred="onDropDownBlurred"
                                               ref="evidence"
                                               :data="enShippingMethod"
                                               :mode="'create'"
                                               :selected-val="filterenShippingMethod"
                                               :header="{multiple: false, label: 'title'}"
                                               aria-placeholder=""
                                               @onChange="onfilterShippingMethodChange"></vs-select>
                                </div>
                            </div>

                            <div class="col-lg-3 mb-1">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نوع فاکتور</span>
                                    </div>
                                    <vs-select @onSearch="onDropDownFocused"
                                               @onSearchBlurred="onDropDownBlurred"
                                               ref="evidence"
                                               :data="eninvoiceType"
                                               :mode="'create'"
                                               :selected-val="filterinvoiceType"
                                               :header="{multiple: false, label: 'title'}"
                                               aria-placeholder=""
                                               @onChange="onfilterInvoiceTypeChange"></vs-select>
                                </div>
                            </div>

                            <div class="col-lg-3 mb-2">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">حداکثر اعتبار</span>
                                    </div>
                                    <date-picker type="date" format="jYYYY/jMM/jDD"
                                                 @input="onCreatemaximumValidityDatePicked"
                                                 :auto-submit="true"
                                                 ref="maximumValidityDate" style="flex: 1">
                                        <slot>
                                            <input v-model="maximumValidityDate"
                                                   class="form-control date-input flex-grow-1" readonly="true"
                                                   @click="toggleCreatemaximumValidityDatePicker">
                                        </slot>
                                    </date-picker>
                                </div>
                            </div>

                            <div class="col-lg-3 mb-1">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">مدت تسویه</span>
                                    </div>
                                    <input type="number" class="form-control"
                                           v-model="supplierInquiryList.settlementPeriodWithSupplier">
                                </div>
                            </div>


                            <div class="col-lg-3 mb-1">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">مجموع قیمت</span>
                                    </div>
                                    <input type="text" class="form-control" readonly="true"
                                           v-model="supplierInquiryList.totalPriceshow">
                                </div>
                            </div>

                        </div>

                    </div>

                    <hr class="w-100"/>
                    <div class="row w-100 p-3">
                        <h4 class="col-12 text-center"> کالاهای استعلام</h4>
                        <div class="col-12 overflow-auto" style="max-height: 12rem;">
                            <table class="table table-hover table-striped mb-3">
                                <thead>

                                <tr>
                                    <th class="text-center text-nowrap">نام کالا</th>
                                    <th class="text-center text-nowrap">واحد</th>
                                    <th class="text-center text-nowrap">تعداد/وزن</th>
                                    <th class="text-center text-nowrap">قیمت کالا</th>
                                    <th class="text-center text-nowrap">مبلغ کل</th>
                                    <th class="text-center text-nowrap">تخفیف</th>
                                    <th class="text-center text-nowrap">خالص خرید</th>
                                    <th class="text-center text-nowrap">ارزش افزوده%</th>
                                    <th class="text-center text-nowrap">مبلغ ارزش افزوده</th>
                                    <th class="text-center text-nowrap">جمع نهایی</th>
                                </tr>

                                </thead>
                                <tbody>
                                <tr v-for="(item) in productPriceInquiry" v-if="item.productCount>0">

                                    <td class="min-vw-50 text-nowrap pb-0">{{item.productName}}</td>
                                    <td class="min-vw-50 text-nowrap pb-0">{{item.unitName}}</td>
                                    <td class="min-vw-50 text-center  pb-0">{{item.productCount}}</td>
                                    <td class="text-center pb-0">
                                        <input class="form-control" style="min-width: 6rem;" type="number"
                                               v-model="item.buyPrice" @input="thousandSeprator(item)">
                                        <small class="text-nowrap mt-2">{{item.buyPriceshow}}</small>
                                    </td>
                                    <td class="text-center pb-0">
                                        <span class="form-control" style="min-width: 6rem;" type="number">
                                                {{(item.totalPrice).toLocaleString()}}</span>
                                        <small class="text-nowrap mt-2">{{item.totalPriceshow}}</small>
                                    </td>
                                    <td class="text-center pb-0">
                                        <input class="form-control" style="min-width: 6rem;" type="number"
                                               v-model="item.discount" @input="thousandSeprator(item)">
                                        <small class="text-nowrap mt-2">{{item.discountshow}}</small>
                                    </td>
                                    <td class="text-center pb-0">
                                        <span class="form-control" style="min-width: 6rem;">{{(item.totalNetPrice).toLocaleString()}}</span>
                                        <small class="text-nowrap mt-2">{{item.totalNetPriceshow}}</small>
                                    </td>
                                    <td class="text-center pb-0">
                                        <input class="form-control" style="min-width: 6rem;" type="number"
                                               v-model="item.vat" @input="thousandSeprator(item)">
                                        <small class="text-nowrap mt-2">{{item.vatshow}}</small>
                                    </td>
                                    <td class="text-center pb-0">
                                        <span class="form-control" style="min-width: 6rem;">{{(item.totalVat).toLocaleString()}}</span>
                                        <small class="text-nowrap mt-2">{{item.totalVatshow}}</small>
                                    </td>
                                    <td class="text-center pb-0">
                                        <span class="form-control" style="min-width: 6rem;">{{(item.totalPriceVat).toLocaleString()}}</span>
                                        <small class="text-nowrap mt-2">{{item.totalPriceVatshow}}</small>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="6"></td>
                                </tr>
                                <tr class="bg-total-discount mt-2">
                                    <td colspan="1"></td>
                                    <td class="text-nowrap text-right ">
                                        <span>جمع کل : </span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>تعداد کل: </span>-->
                                        <span v-if="isNaN(sumproductcount)" class="text-warning">تعداد به درستی وارد نشده است!</span>
                                        <span v-else>{{this.sumproductcount}}</span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>قیمت کالا: </span>-->
                                        <span v-if="isNaN(tbuyprice)"
                                              class="text-warning">مبلغ به درستی وارد نشده است!</span>
                                        <span v-else>{{(this.tbuyprice).toLocaleString()}}</span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>قیمت کل: </span>-->
                                        <span v-if="isNaN(ttotalPrice)" class="text-warning">مبلغ به درستی وارد نشده است!</span>
                                        <span v-else>{{(this.ttotalPrice).toLocaleString()}}</span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>جمع تخفیف : </span>-->
                                        <span v-if="isNaN(tdiscount)"
                                              class="text-warning">قیمت به درستی وارد نشده است!</span>
                                        <span v-else>{{(this.tdiscount).toLocaleString()}}</span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>جمع بعد از تخفیف : </span>-->
                                        <span v-if="isNaN(ttotalNetPrice)"
                                              class="text-warning">قیمت به درستی وارد نشده است!</span>
                                        <span v-else>{{(this.ttotalNetPrice).toLocaleString()}}</span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>جمع بعد از تخفیف : </span>-->
                                        <span v-if="isNaN(tvat)"
                                              class="text-warning">قیمت به درستی وارد نشده است!</span>
                                        <span v-else>{{(this.tvat).toLocaleString()}}</span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>جمع بعد از تخفیف : </span>-->
                                        <span v-if="isNaN(ttotalVat)"
                                              class="text-warning">قیمت به درستی وارد نشده است!</span>
                                        <span v-else>{{(this.ttotalVat).toLocaleString()}}</span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>جمع بعد از تخفیف : </span>-->
                                        <span v-if="isNaN(ttotalPriceVat)"
                                              class="text-warning">قیمت به درستی وارد نشده است!</span>
                                        <span v-else>{{(this.ttotalPriceVat).toLocaleString()}}</span>
                                    </td>
                                </tr>

                                </tbody>
                            </table>


                        </div>

                        <div class="col-lg-6 offset-lg-3 text-center">
                            <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                    @click="updateSuplierInquiry" v-if="inquiriMode==='edit'">ویرایش استعلام
                            </button>
                            <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                    @click="createSupplierInquiry" v-else>ثبت استعلام
                            </button>
                            <button class="btn btn-primary btn-round clickable mt-3 mx-3"
                                    @click="cancelNewSupplierInquiry">انصراف
                            </button>
                        </div>
                    </div>
                </div>

            </modal>
            <!--////////////////////////////////////////////تلفن جدید////////////////////////////////////-->
            <modal show="false" ref="insertModal" v-if="showNewCustomerPhone">
                    <div class="row p-3">
                        <div class="col-12 text-center">
                            <h1 >ثبت تلفن های تامین کننده </h1>
                            <h1 >{{this.filtersupplier.fullName}}</h1>
                        </div>


                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">نام انبار/بخش</span>
                                </div>
                                <input class="form-control" v-model="customerPhoneModel.departmentName">
                            </div>
                        </div>
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">نام مسئول انبار/بخش</span>
                                </div>
                                <input class="form-control" v-model="customerPhoneModel.customeremployeeFullName">
                            </div>
                        </div>
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">شماره همراه</span>
                                </div>
                                <input type="number" class="form-control" v-model="customerPhoneModel.cellPhoneNumber">
                            </div>
                        </div>

                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">شماره ثابت</span>
                                </div>
                                <input type="number" class="form-control" v-model="customerPhoneModel.phoneNumber">
                            </div>
                        </div>

                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">ایمیل</span>
                                </div>
                                <input type="email" class="form-control" v-model="customerPhoneModel.customerEmailAddress">
                            </div>
                        </div>



                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">آدرس انبار/بخش</span>
                                </div>
                                <input class="form-control" v-model="customerPhoneModel.wareHouseAddress">
                            </div>
                        </div>
                        <h4 class="col-12 text-center"> تلفن های تامین کننده</h4>
                        <div class="col-12 overflow-auto" style="max-height: 12rem;">
                            <table class="table table-hover table-striped mb-3">
                                <thead>

                                <tr>
                                    <th class="text-center text-nowrap">نام انبار/بخش</th>
                                    <th class="text-center text-nowrap">نام مسئول مربوطه</th>
                                    <th class="text-center text-nowrap">تلفن همراه</th>
                                    <th class="text-center text-nowrap">تلفن ثابت</th>
                                    <th class="text-center text-nowrap">ایمیل</th>
                                    <th class="text-center">عملیات</th>

                                </tr>

                                </thead>
                                <tbody>
                                <tr v-for="item in customerPhone" v-if="item.customerId>0">
                                    <td class="text-center text-nowrap">{{item.departmentName}}</td>
                                    <td class="text-center text-nowrap">{{item.customeremployeeFullName}}</td>
                                    <td class="text-center text-nowrap">{{item.cellPhoneNumber}}</td>
                                    <td class="text-center text-nowrap">{{item.phoneNumber}}</td>
                                    <td class="text-center text-nowrap">{{item.customerEmailAddress}}</td>
                                    <td class="text-center text-nowrap"><i
                                            class="fa fa-pencil-square-o px-3 clickable"
                                            style="font-size: larger"
                                            @click="editPhoneItem(item)"
                                            title="ویرایش آیتم"></i>
                                        | <i class="fa fa-trash-o px-3 clickable"
                                             style="font-size: larger"
                                             @click="deletePhoneItem(item)"
                                             title="حذف آیتم"></i>
                                    </td>

                                </tr>


                                </tbody>
                            </table>


                        </div>


                        <div class="col-lg-6 offset-lg-3 text-center">
                            <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                    @click="updateCustomerPhone" v-if="customerphoneMode==='edit'">ویرایش تلفن
                            </button>
                            <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                    @click="createCustomerPhone" v-else>ثبت تلفن
                            </button>
                            <button class="btn btn-primary btn-round clickable mt-3 mx-3"
                                    @click="cancelCustomerPhone">بازگشت
                            </button>
                        </div>
                    </div>
            </modal>
            <!--/////////////////////////////////////تامین کننده جدید///////////////////////////////////////////////////-->
            <modal show="false" ref="insertModal" v-if="showNewCustomer">
                <div class="row p-3">
                    <div class="col-12 text-center">
                        <h1 v-if="supplierMode === 'create'">ثبت تامین کننده</h1>
                        <h1 v-else>ویرایش تامین کننده</h1>
                    </div>
                    <div class="col-lg-3 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">کد تامین کننده</span>
                            </div>
                            <input class="form-control" v-model="supplierModel.customerCode">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">نام</span>
                            </div>
                            <input class="form-control" v-model="supplierModel.name">
                        </div>
                    </div>
                    <div class="col-lg-5 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">نام خانوادگی/شرکت</span>
                            </div>
                            <input class="form-control" v-model="supplierModel.family">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">کد/شناسه ملی</span>
                            </div>
                            <input class="form-control" v-model="supplierModel.nationalCode">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">کد اقتصادی</span>
                            </div>
                            <input class="form-control" v-model="supplierModel.taxCode">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">کد پستی</span>
                            </div>
                            <input class="form-control" v-model="supplierModel.postalCode">
                        </div>
                    </div>

                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">شماره تلفن همراه</span>
                            </div>
                            <input type="number" class="form-control" v-model="supplierModel.mobile">
                        </div>
                    </div>

                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">شماره ثابت</span>
                            </div>
                            <input type="number" class="form-control" v-model="supplierModel.phone">
                        </div>
                    </div>

                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">ایمیل</span>
                            </div>
                            <input type="email" class="form-control" v-model="supplierModel.email">
                        </div>
                    </div>



                    <div class="col-lg-8 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">آدرس</span>
                            </div>
                            <input class="form-control" v-model="supplierModel.address">
                        </div>
                    </div>


                    <div class="col-lg-6 offset-lg-3 text-center">
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="updatesupplierInSupplierInquiry" v-if="supplierMode==='edit'">ویرایش تامین کننده
                        </button>
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="createsupplierInSupplierInquiry" v-else>ثبت تامین کننده
                        </button>
                        <button class="btn btn-primary btn-round clickable mt-3 mx-3"
                                @click="cancelsupplierInSupplierInquiry">بازگشت
                        </button>
                    </div>
                </div>
            </modal>

        </div>
    </div>
</template>

<script>
    import BaseService from "../../_framework/api/BaseService";
    import DatePicker from '../../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect";
    import Utils from "../../_framework/utils/Utils";
    import Moment from 'moment-jalali';
    import Constants from "../../_framework/Constants";

    export default {
        name: "supplierinquiris",
        components: {VsSelect, DatePicker},
        data() {
            return {
                showNewCustomerPhone:false,
                showNewCustomer:false,
                isLoading: true,
                inquiriMode: "",
                inquiriModel: {
                    userId: "",
                    createdate: "",
                    inquiriType: "",
                    inquirynumber: "",
                    registrationDate: "",
                    customerId: "",
                    name: "",
                    family: "",
                    fullName: "",
                    mobile: "",
                    startDate: "",
                    startHour: "",
                    expiryDate: "",
                    expiryHour: "",
                    settlementPeriod: "",
                    employeeId: "",
                    guaranteeAmount: 0,
                    inquiryStatus: "",

                },
                inquirisList: [],
                supplierList: [],
                inquiryId: "",
                inquirydate: "",
                inquiryStartdate: "",
                inquiryEnddate: "",
                maxtime: 2400,
                fromhour: 0,
                tohour: 0,
                eninquiritype: [],
                selectedinquiritype: "",
                inquiriType: "",
                fullName: "",

                products: [{
                    inquiryId: "",
                    productId: "",
                    productName: "",
                    productCode: "",
                    unitId: "",
                    unitName: "",
                    productCount: "",
                    descriptionOnSite: "",
                    needSample: "",
                    samplevalue: "",
                    row: ""
                }],
                selectedproduct: {},
                selectedinquiryproduct: [],
                productsInquiry: [{
                    inquiryId: "",
                    productId: "",
                    productName: "",
                    productCode: "",
                    unitId: "",
                    unitName: "",
                    productCount: "",
                    descriptionOnSite: "",
                    needSample: "",
                    samplevalue: "",
                    row: ""
                }],
                productarrayMode: "",
                productMode: "",
                productModel: {
                    inquiryId: "",
                    productId: "",
                    productName: "",
                    productCode: "",
                    unitId: "",
                    unitName: "",
                    productCount: "",
                    descriptionOnSite: "",
                    needSample: "",
                    samplevalue: "",
                    row: ""
                },
                productInquiryModel: {
                    inquiryId: "",
                    productId: "",
                    unitId: "",
                    productCount: "",
                    descriptionOnSite: "",
                    needSample: "",
                    row: 0,
                },
                productinquirisList: [],
                productName: "",
                productCode: "",
                unitId: "",
                unitName: "",
                selectedUnit: [],
                productCount: "",
                description: "",
                needSample: "",
                sampletitle: "",
                units: [],
                selectedUnits: "",
                selectedSample: [],
                samplevalue: "",
                ensamples: [],
                filterinvoiceType: "",
                invoicevalue: "",
                eninvoiceType: [],
                sampleid: "",
                rows: 0,
                checksaveok: false,
                showinquiry: true,
                showsupplierinquiry: false,
                inquirystatuslist: [],

                customers2: [{
                    address: "",
                    birthday: "",
                    companyId: "",
                    createOn: "",
                    customerCode: "",
                    customerType: "",
                    email: "",
                    endCorporation: "",
                    family: "",
                    fatherName: "",

                    fullName: "",
                    id: "",
                    mobile: "",
                    name: "",
                    nationalCode: "",
                    phone: "",
                    postalCode: "",
                    taxCode: "",

                }],


                voucher: {
                    description: "",
                    receiveOutSourceId: 0,
                    voucherProductDto: [],
                    outSourceName: "",
                    overallAmount: 0,
                    overallPrice: 0,
                    discount: 0,
                    voucherDate: "0001-01-01",
                },


                preselectedUnit: {},
                voucherDiscount: 0,
                voucherNoDiscount: 0,

                productPriceInquiry: [{
                    id: "",
                    supplierInquiryId: "",
                    inquiryId: "",
                    needSample: "",
                    productId: "",
                    productName: "",
                    productCode: "",
                    unitId: "",
                    unitName: "",
                    productCount: "",
                    descriptionOnSite: "",
                    row: 0,
                    buyPrice: 0,
                    totalPrice: 0,
                    discount: 0,
                    totalNetPrice: 0,
                    vat: 0,
                    totalVat: 0,
                    totalPriceVat: 0,
                    vatshow: "",
                    buyPriceshow: "",
                    totalPriceshow: "",
                    discountshow: "",
                    totalNetPriceshow: "",
                    totalVatshow: "",
                    totalPriceVatshow: "",
                }],
                productPriceInquiryModel: {
                    supplierInquiryId: "",
                    inquiryId: "",
                    row: 0,
                    productId: "",
                    unitId: "",
                    productCount: "",
                    buyPrice: 0,
                    totalPrice: 0,
                    discount: 0,
                    totalNetPrice: 0,
                    vat: 0,
                    totalVat: 0,
                    totalPriceVat: 0,

                },
                supplierinquiryId: "",
                filtersupplier: "",
                suppliers: [],

                ///////////////////////////////////////////////////////////////
                ////////// new var                              ///////////////
                ///////////////////////////////////////////////////////////////

                tproductCount: 0,
                tbuyprice: 0,
                ttotalPrice: 0,
                tdiscount: 0,
                ttotalNetPrice: 0,
                tvat: 0,
                ttotalVat: 0,
                ttotalPriceVat: 0,

                vatshow: 0,
                buyPriceshow: 0,
                totalPriceshow: 0,
                discountshow: 0,
                totalNetPriceshow: 0,
                totalVatshow: 0,
                totalPriceVatshow: 0,


                enShippingMethod: [],
                maxvat: 10,
                filterenShippingMethod: "",
                supplierinquiry: [],
                supplierInquiryProducts: [],
                maximumValidityDate: "",
                sumproductcount: 0,
                sumbuyprice: 0,
                sumtotalprice: 0,
                sumdiscount: 0,
                sumtotalnetprice: 0,
                sumVat: 0,
                sumtotalvat: 0,
                sumtotalpricevat: 0,
                supplierInquiryDate: "",
                supplierInquiryList: {

                    Id: "",
                    supplierInquiryId: "",
                    inquiryId: "",
                    row: "",
                    supplierInquiryDate: "",
                    supplierInquiryHour: "",
                    customerId: "",
                    customerCode: "",
                    customerFullName: "",
                    nationalCode: "",
                    mobile: "",
                    shippingMethod: "",
                    invoiceType: "",
                    totalPrice: "",
                    totalPriceshow: "",
                    maximumValidityDate: "",
                    settlementPeriodWithSupplier: "",
                    sampleProduct: "",
                    sampleShipmentCode: "",
                    actionerId: "",
                    otherExplanations: "",
                    proformaInvoiceStatus: "",

                    status: "",

                },
                supplierInquiryModel: {

                    inquiryId: "",
                    userId: "",
                    row: "",
                    supplierInquiryDate: "",
                    supplierInquiryHour: "",
                    customerId: "",
                    employeeId: "",
                    shippingMethod: "",
                    invoiceType: "",
                    totalPrice: "",
                    maximumValidityDate: "",
                    settlementPeriodWithSupplier: "",
                    sampleProduct: false,
                    sampleShipmentCode: "",
                    actionerId: "",
                    otherExplanations: "",
                    proformaInvoiceStatus: false,
                    status: "",
                },
                supplierInquiryUpdateModel: {
                    id :"",
                    inquiryId: "",
                    userId: "",
                    row: "",
                    supplierInquiryDate: "",
                    supplierInquiryHour: "",
                    customerId: "",
                    employeeId: "",
                    shippingMethod: "",
                    invoiceType: "",
                    totalPrice: "",
                    maximumValidityDate: "",
                    settlementPeriodWithSupplier: "",
                    sampleProduct: false,
                    sampleShipmentCode: "",
                    actionerId: "",
                    otherExplanations: "",
                    proformaInvoiceStatus: false,

                    status: "",
                },

                supplierMode: "",
                supplierModel: {
                    id: 0,
                    customerCode : "",
                    name: "",
                    family: "",
                    fullName: "",
                    fatherName: "",
                    mobile: "",
                    phone : "",
                    address: "",
                    postalCode :"",

                    email : "",
                    birthday :"",
                    nationalCode : "",
                    taxCode : "",
                    companeyId : 0,
                    customerType : 1,



                },
                displayexpiryHour: "",
                displaystartHour: "",
                displaytimecheck :"",
                displaysupplierInquiryHour :"",
                timecheck :"",
                customerphoneMode:"create",
                customerPhone :[{
                    phoneNumber: "",
                    customerId: "",
                    customerPersonId: "",
                    description: "",
                    companyId: 0,
                    wareHouseId: "",

                    cellPhoneNumber: "",
                    customeremployeeFullName: "",
                    customerEmailAddress: "",
                    departmentName: "",
                    wareHouseAddress: "",
                }],
                customerPhoneShow :[{
                    phoneNumber: "",
                    customerId: "",
                    customerPersonId: "",
                    description: "",
                    companyId: 0,
                    wareHouseId: "",
                    cellPhoneNumber: "",
                    customeremployeeFullName: "",
                    customerEmailAddress: "",
                    departmentName: "",
                    wareHouseAddress: "",
                    showName :""
                }],
                customerPhoneModel : {
                    id :0,
                    phoneNumber: "",
                    customerId: "",
                    customerPersonId: "",
                    description: "",
                    companyId: 0,
                    wareHouseId: "",

                    cellPhoneNumber: "",
                    customeremployeeFullName: "",
                    customerEmailAddress: "",
                    departmentName: "",
                    wareHouseAddress: "",
                },
                filtercustomerphone : "",
                tablecustomerphone :[],
                // /////////////////////////////////////////////////////////////
                ////////// old var                              ///////////////
                ///////////////////////////////////////////////////////////////

                myinquiris: [],

                customerFollowMode: "",
                customerFollowModel: {
                    id: 0,
                    customerId: 0,
                    productId: 0,

                    date: "",
                    nextDate: "",

                    status: 0,
                    description: "",
                    followerId: 0,
                },


                newstartDate: "",
                newendDate: "",
                search: "",
                customers: [{
                    address: "",
                    birthday: "",
                    companyId: "",
                    createOn: "",
                    customerCode: "",
                    customerType: "",
                    email: "",
                    endCorporation: "",
                    family: "",
                    fatherName: "",

                    fullName: "",
                    id: "",
                    mobile: "",
                    name: "",
                    nationalCode: "",
                    phone: "",
                    postalCode: "",
                    taxCode: "",
                }],
                filtercustomer: [],
                customerName: "",
                customerFather: "",
                customerMobile: "",
                customerId: 0,
                searchcustomer: "",
                showMyRegister :false,
                showArchive: false,
                showReciveDate: false,
                isSending: false,
                accountPanel: false,
                nextFollow: false,
                mycustomer: [],
                selectedbazaryab: {},

                selectedmoaref: {},
                users: [],

                selectedcustomer: {},
                followStatus: {},

                customerModel: {
                    id: 0,
                    family: "",
                    name: "",
                    mobile: "",
                    fatherName: "",
                    address: "",

                },
                ////////////////////// End  Old var/////////////////////////////////
                ////////////////////// Daily Reports Parameter /////////////////////////////////
                dailyReportModel: {
                    id: 0,
                    description: "",
                    day : "",
                    fromTime : "",
                    toTime : "",
                    totalWork : "",
                    titleWorkId : "",
                    bossId :"",
                    bossApprovalDate : "",
                    managerId : "",
                    managerApprovalDate: "",
                    companyId: 0,
                    managerDescription :"",
                    bossDescription :"",
                },
                dateObj :"",
                currentDate :"",
                hFrom :"",
                mFrom :"",
                hTo :"",
                mTo :"",
                totaltime:"",
                hourTotal:"",
                minuteTotal:"",
                displaytotalWork :"",
                dailyReportMode : "create" ,
                invoiceType : "",
                //////////////////////End  Daily Reports Parameter /////////////////////////////////
            }
        },
        mounted() {


            this.getunits();
            this.getenSample();
            this.getEnInquiriType();
            this.getEnShippingMethod();
            this.getInquiryStatus();
            this.getEnInvoiceType();
            this.getInquirisList();

            this.getproducts();
            this.getcustomers();
            this.getcustomers2();
            this.getsuppliers();
            //this.getProductInquiry();
        },
        methods: {
            getInquiryStatus() {
                new BaseService("enum", "/GetEnInquiriStatus").getList().then(response => {
                    this.inquirystatuslist = response.data;
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                });

            },



            setInquiryStatusName() {
                if (this.inquirisList && this.inquirystatuslist) {
                    for (let inquirylist of this.inquirisList) {
                        for (let res of this.inquirystatuslist) {
                            if (inquirylist.inquiryStatus === res.value) {
                                inquirylist.inquiryStatusName = res.title;
                            }
                        }

                    }
                }
            },
            createSupplierInquiry() {

                this.isSending = true;
                if (this.supplierInquiryList.inquiryId == null || this.supplierInquiryList.inquiryId === "") {
                    Utils.handleErrorWithNotification("مشخصات نیاز به درستی ثبت نشده است. لطفا از این فرم خارج و مجددا امتحان کنید", this.$noty);
                } else if (this.supplierInquiryList.supplierInquiryDate === "") {
                    Utils.handleErrorWithNotification("تاریخ استعلام قیمت ثبت نشده است.", this.$noty);
                } else if (this.supplierInquiryList.supplierInquiryHour === "" || this.supplierInquiryList.supplierInquiryHour === null
                    || this.supplierInquiryList.supplierInquiryHour === undefined) {
                    Utils.handleErrorWithNotification("ساعت  استعلام قیمت ثبت نشده است.", this.$noty);
                } else if (this.supplierInquiryList.customerId === "") {
                    Utils.handleErrorWithNotification("تامین کننده انتخاب نشده است .", this.$noty);
                } else if (this.supplierInquiryList.shippingMethod === 0) {
                    Utils.handleErrorWithNotification("نوع حمل انتخاب نشده است.", this.$noty);
                } else if (this.supplierInquiryList.invoiceType === 0) {
                    Utils.handleErrorWithNotification("نوع فاکتور انتخاب نشده است.", this.$noty);
                } else if (this.supplierInquiryList.maximumValidityDate === "") {
                    Utils.handleErrorWithNotification("اعتبار استعلام ثبت نشده است.", this.$noty);
                } else if (this.supplierInquiryList.settlementPeriodWithSupplier === "") {
                    Utils.handleErrorWithNotification("مدت تسویه فاکتور ثبت نشده است.", this.$noty);
                } else {
                    let i = 0;
                    let countpr = 0;
                    for (let pr of this.productPriceInquiry) {
                        if (pr.productCount > 0 && pr.buyPrice === 0) {
                            i++;
                        }
                        if (pr.productCount > 0) {
                            countpr++;
                        }
                    }

                    if (i > 0) {
                        if (confirm("قیمت برخی از کالا ها ثبت نشده است .آیا مایل به ثبت اطلاعات هستید؟")) {
                        } else {
                            Utils.handleErrorWithNotification("لطفا قیمت تمام کالا ها را چک کنید", this.$noty);
                            this.isSending = false;
                            return;
                        }
                    }


                    this.supplierInquiryModel.inquiryId = this.supplierInquiryList.inquiryId;
                    this.supplierInquiryModel.userId = this.supplierInquiryList.userId;
                    this.supplierInquiryModel.row = 1;
                    this.supplierInquiryModel.supplierInquiryDate = Moment(this.supplierInquiryList.supplierInquiryDate).format('YYYY/MM/DD HH:mm');
                    this.supplierInquiryModel.supplierInquiryHour = this.supplierInquiryList.supplierInquiryHour;
                    this.supplierInquiryModel.customerId = this.supplierInquiryList.customerId;
                    this.supplierInquiryModel.employeeId = "";
                    this.supplierInquiryModel.shippingMethod = this.supplierInquiryList.shippingMethod;
                    this.supplierInquiryModel.invoiceType = this.supplierInquiryList.invoiceType;
                    this.supplierInquiryModel.totalPrice = this.supplierInquiryList.totalPrice;
                    this.supplierInquiryModel.maximumValidityDate = this.supplierInquiryList.maximumValidityDate;
                    this.supplierInquiryModel.settlementPeriodWithSupplier = this.supplierInquiryList.settlementPeriodWithSupplier;
                    this.supplierInquiryModel.otherExplanations = "";
                    this.supplierInquiryModel.proformaInvoiceStatus = false;
                    this.supplierInquiryModel.actionerId = "";
                    this.supplierInquiryModel.status = 2;
                    this.supplierInquiryModel.userId = "";

                    this.dateObj = new Date().toJSON();
                    this.currentDate = this.gregorianToJalali(this.dateObj, false)
                    this.dailyReportModel.toTime = Moment(this.currentDate).format('YYYY/MM/DD HH:mm');
                    this.createdailyReport();

                    if (countpr === 0) {
                        new BaseService("SupplierInquiry", "/CreateSupplierInquirys").create(this.supplierInquiryModel).then(response => {
                            this.supplierinquiryId = response.data;
                            this.supplierInquiryList.supplierInquiryId = response.data;
                            this.isSending = false;
                            this.checksaveok = false;
                            this.showinquiry = true;
                            this.showsupplierinquiry = false;
                        }).catch(error => {
                            this.isSending = false;
                            Utils.handleErrorWithNotification(error.data, this.$noty);
                        });
                    }
                    else {
                        new BaseService("SupplierInquiry", "/CreateSupplierInquirys").create(this.supplierInquiryModel).then(response => {
                            this.supplierinquiryId = response.data;
                            this.supplierInquiryList.supplierInquiryId = response.data;
                            this.isSending = false;
                            this.checksaveok = false;
                            this.showinquiry = true;
                            this.showsupplierinquiry = false;

                            new BaseService("SupplierInquiryProducts", "/DeleteSupplierInquiryProducts").delete(this.supplierinquiryId).then(response => {

                            }).catch(error => {
                                this.isSending = false;
                                Utils.handleErrorWithNotification(error.data, this.$noty);
                                this.$refs.insertModal.hideModal();
                                this.getInquirisList();
                            });

                            var productsSupplierInquiryList = [];

                            for (let pr of this.productPriceInquiry) {
                                if (pr.productCount > 0) {
                                    this.productPriceInquiryModel.supplierInquiryId = this.supplierInquiryList.supplierInquiryId;
                                    this.productPriceInquiryModel.inquiryId = pr.inquiryId;
                                    this.productPriceInquiryModel.productId = pr.productId;
                                    this.productPriceInquiryModel.unitId = pr.unitId;
                                    this.productPriceInquiryModel.productCount = pr.productCount;
                                    this.productPriceInquiryModel.buyPrice = pr.buyPrice;
                                    this.productPriceInquiryModel.totalPrice = pr.totalPrice;
                                    this.productPriceInquiryModel.discount = pr.discount;
                                    this.productPriceInquiryModel.totalNetPrice = pr.totalNetPrice;
                                    this.productPriceInquiryModel.vat = pr.vat;
                                    this.productPriceInquiryModel.totalVat = pr.totalVat;
                                    this.productPriceInquiryModel.totalPriceVat = pr.totalPriceVat;

                                    productsSupplierInquiryList.push(this.productPriceInquiryModel);
                                    this.productPriceInquiryModel = {
                                        supplierInquiryId: "",
                                        inquiryId: "",
                                        row: 0,
                                        productId: "",
                                        unitId: "",
                                        productCount: "",
                                        buyPrice: 0,
                                        totalPrice: 0,
                                        discount: 0,
                                        totalNetPrice: 0,
                                        vat: 0,
                                        totalVat: 0,
                                        totalPriceVat: 0,

                                    };
                                }
                            }

                            var model = {
                                SupplierInquiryProductlist: productsSupplierInquiryList
                            };

                            new BaseService("SupplierInquiryProducts", "/CreateSupplierInquiryProductsList").create( model).then(response => {
                                this.$noty.success("استعلام با موفقیت ثبت شد");

                                this.isSending = false;
                                this.checksaveok = false;
                                this.showinquiry = true;
                                this.showsupplierinquiry = false;
                                this.getSupplierInquiryLists();
                                //this.$refs.insertModal.hideModal();
                            }).catch(error => {
                                this.isSending = false;
                                Utils.handleErrorWithNotification(error.data, this.$noty);
                                //this.$refs.insertModal.hideModal();
                            });
                        }).catch(error => {
                            this.isSending = false;
                            Utils.handleErrorWithNotification(error.data, this.$noty);
                        });

                    }

                }
            },
            addSupplierInquiryProducts() {
                if(this.supplierInquiryList.supplierInquiryId>0){
                    this.deleteSupplierInquiryProducts(this.supplierInquiryList.supplierInquiryId);
                }

                var productsSupplierInquiryList = [];

                for (let pr of this.productPriceInquiry) {
                    if (pr.productCount > 0) {
                        this.productPriceInquiryModel.supplierInquiryId = this.supplierInquiryList.supplierInquiryId;
                        this.productPriceInquiryModel.inquiryId = pr.inquiryId;
                        this.productPriceInquiryModel.productId = pr.productId;
                        this.productPriceInquiryModel.unitId = pr.unitId;
                        this.productPriceInquiryModel.productCount = pr.productCount;
                        this.productPriceInquiryModel.buyPrice = pr.buyPrice;
                        this.productPriceInquiryModel.totalPrice = pr.totalPrice;
                        this.productPriceInquiryModel.discount = pr.discount;
                        this.productPriceInquiryModel.totalNetPrice = pr.totalNetPrice;
                        this.productPriceInquiryModel.vat = pr.vat;
                        this.productPriceInquiryModel.totalVat = pr.totalVat;
                        this.productPriceInquiryModel.totalPriceVat = pr.totalPriceVat;

                        productsSupplierInquiryList.push(this.productPriceInquiryModel);
                        this.productPriceInquiryModel = {
                            supplierInquiryId: "",
                            inquiryId: "",
                            row: 0,
                            productId: "",
                            unitId: "",
                            productCount: "",
                            buyPrice: 0,
                            totalPrice: 0,
                            discount: 0,
                            totalNetPrice: 0,
                            vat: 0,
                            totalVat: 0,
                            totalPriceVat: 0,

                        };
                    }
                }

                var model = {
                    SupplierInquiryProductlist: productsSupplierInquiryList
                };

                new BaseService("SupplierInquiryProducts", "/CreateSupplierInquiryProductsList").create(model).then(response => {
                    this.$noty.success("استعلام با موفقیت ثبت شد");

                    this.isSending = false;
                    this.checksaveok = false;
                    this.showinquiry = true;
                    this.showsupplierinquiry = false;
                    this.getSupplierInquiryLists();
                    //this.$refs.insertModal.hideModal();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                });

            },
            updateSuplierInquiry() {
                if (this.supplierInquiryList.inquiryId == null || this.supplierInquiryList.inquiryId === "") {
                    Utils.handleErrorWithNotification("مشخصات نیاز به درستی ثبت نشده است. لطفا از این فرم خارج و مجددا امتحان کنید", this.$noty);
                } else if (this.supplierInquiryList.supplierInquiryDate === "") {
                    Utils.handleErrorWithNotification("تاریخ استعلام قیمت ثبت نشده است.", this.$noty);
                } else if (this.supplierInquiryList.supplierInquiryHour === "" || this.supplierInquiryList.supplierInquiryHour == null || this.supplierInquiryList.supplierInquiryHour === undefined) {
                    Utils.handleErrorWithNotification("ساعت  استعلام قیمت ثبت نشده است.", this.$noty);
                } else if (this.supplierInquiryList.customerId === "") {
                    Utils.handleErrorWithNotification("تامین کننده انتخاب نشده است .", this.$noty);
                } else if (this.supplierInquiryList.shippingMethod === 0) {
                    Utils.handleErrorWithNotification("نوع حمل انتخاب نشده است.", this.$noty);
                } else if (this.supplierInquiryList.invoiceType === 0) {
                    Utils.handleErrorWithNotification("نوع فاکتور انتخاب نشده است.", this.$noty);
                } else if (this.supplierInquiryList.maximumValidityDate === "") {
                    Utils.handleErrorWithNotification("اعتبار استعلام ثبت نشده است.", this.$noty);
                } else if (this.supplierInquiryList.settlementPeriodWithSupplier === "") {
                    Utils.handleErrorWithNotification("مدت تسویه فاکتور ثبت نشده است.", this.$noty);
                } else {
                    let i = 0;
                    for (let pr of this.productPriceInquiry) {
                        if (pr.productCount > 0 && pr.buyPrice === 0) {
                            i++;
                        }
                    }
                    if (i > 0) {
                        if (confirm("قیمت برخی از کالا ها ثبت نشده است .آیا مایل به ثبت اطلاعات هستید؟")) {
                        } else {
                            Utils.handleErrorWithNotification("لطفا قیمت تمام کالا ها را چک کنید", this.$noty);
                            return;
                        }
                    }

                    this.supplierInquiryModel.id = this.supplierInquiryList.supplierInquiryId;
                    this.supplierInquiryModel.inquiryId = this.supplierInquiryList.inquiryId;
                    this.supplierInquiryModel.userId = this.supplierInquiryList.userId;
                    this.supplierInquiryModel.row = this.supplierInquiryList.row;
                    this.supplierInquiryModel.supplierInquiryDate = this.supplierInquiryList.supplierInquiryDate;
                    this.supplierInquiryModel.supplierInquiryHour = this.supplierInquiryList.supplierInquiryHour;
                    this.supplierInquiryModel.customerId = this.supplierInquiryList.customerId;
                    this.supplierInquiryModel.employeeId = this.supplierInquiryList.employeeId;
                    this.supplierInquiryModel.shippingMethod = this.supplierInquiryList.shippingMethod;
                    this.supplierInquiryModel.invoiceType = this.supplierInquiryList.invoiceType;
                    this.supplierInquiryModel.totalPrice = this.supplierInquiryList.totalPrice;
                    this.supplierInquiryModel.maximumValidityDate = this.supplierInquiryList.maximumValidityDate;
                    this.supplierInquiryModel.settlementPeriodWithSupplier = this.supplierInquiryList.settlementPeriodWithSupplier;
                    this.supplierInquiryModel.status = this.supplierInquiryList.status;
                    this.supplierInquiryModel.actionerId = "";

                    this.addSupplierInquiryProducts();
                    new BaseService("SupplierInquiry", "/UpdateSupplierInquirys").update(this.supplierInquiryModel).then(response => {
                        this.supplierinquiryId = response.data;

                        this.$noty.success("استعلام با موفقیت ویرایش شد");
                        this.$refs.insertModal.hideModal();
                        this.isSending = false;
                        this.getInquirisList();
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                        this.$refs.insertModal.hideModal();
                        this.getInquirisList();
                    });
                    this.dateObj = new Date().toJSON();
                    this.currentDate = this.gregorianToJalali(this.dateObj, false);
                    this.dailyReportModel.toTime = Moment(this.currentDate).format('YYYY/MM/DD HH:mm');
                    this.createdailyReport();
                }
            },
            deleteSupplierInquiryProducts(val) {
                new BaseService("SupplierInquiryProducts", "/DeleteSupplierInquiryProducts").delete(val).then(response => {

                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                    this.getInquirisList();
                });
            },




            getenSample() {
                new BaseService("enum", "/GetEnHaveNoHave").getList().then(response => {
                    this.ensamples = response.data;

                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getEnInvoiceType() {
                new BaseService("enum", "/GetEnInvoiceType").getList().then(response => {
                    this.eninvoiceType = response.data;

                   }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },


            getEnInquiriType() {
                new BaseService("enum", "/GetEnInquiriType").getList().then(response => {
                    this.eninquiritype = response.data;

                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },



            getEnShippingMethod() {
                new BaseService("enum", "/GetEnShippingMethod").getList().then(response => {

                    for(let list of response.data) {
                        if (parseInt(list.value) < 10) {
                            this.enShippingMethod.push({
                                title: list.title,
                                value: list.value,
                            });
                        }
                    }

                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getunits() {
                new BaseService("unit", "/Getunit").getList().then(response => {
                    this.units = response.data;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getInquirisList() {
                var status = 1;
                new BaseService("Inquiry", `/GetInquirysByStatus/${status}`).getList().then(response => {
                    this.inquirisList = response.data;
                    this.setInquiryStatusName();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                });

            },
            onMyRegistrationRecordClicked() {
                if(this.showMyRegister)
                {
                    this.showMyRegister=false;
                    this.getInquirisList();
                }
                else {
                    this.showMyRegister = true;

                    var status = 3;
                    new BaseService("Inquiry", `/GetUserInquirysByStatus/${status}`).getList().then(response => {
                        this.inquirisList = response.data;
                        this.setInquiryStatusName();
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                        this.$refs.insertModal.hideModal();
                    });
                }
            },
            onArchiveClicked() {
                if(this.showArchive)
                {
                    this.showArchive=false;
                    this.getInquirisList();
                }
                else {
                    this.showArchive = true;

                    var status = 3;
                    new BaseService("Inquiry", `/GetInquirysByStatus/${status}`).getList().then(response => {
                        this.inquirisList = response.data;
                        this.setInquiryStatusName();
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                        this.$refs.insertModal.hideModal();
                    });
                }
            },
            getproducts() {
                new BaseService("product", "/Getproduct").getList().then(response => {
                    this.products = response.data;

                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            onChangestartHour() {
                this.inquiriModel.startHour = this.checkTime(this.inquiriModel.startHour);
                this.displaystartHour =this.setDisplayTime(this.inquiriModel.startHour);
            },
            onChangeexpiryHour() {
                this.inquiriModel.expiryHour = this.checkTime(this.inquiriModel.expiryHour);
                this.displayexpiryHour =this.setDisplayTime(this.inquiriModel.expiryHour);
            },
            onChangesupplierInquiryTime() {
                this.supplierInquiryList.supplierInquiryHour = this.checkTime(this.supplierInquiryList.supplierInquiryHour);
                this.displaysupplierInquiryHour =this.setDisplayTime(this.supplierInquiryList.supplierInquiryHour);

            },
            onChangesettlement() {
                if (parseInt(this.inquiriModel.settlementPeriod) > 160) {
                    this.$noty.error("مدت تسویه خیلی زیاد است");
                }
            },
            checkTime(val) {

                this.timecheck = val;
                if (parseInt(this.timecheck) > this.maxtime) {
                    if (parseInt(this.timecheck.toString().substr(0, 2)) >= 24) {
                        this.timecheck = this.maxtime;
                    }
                    else if (parseInt(this.timecheck.toString().substr(4, 2)) >= 60) {

                        this.timecheck = val.toString().substr(0, 2) + "59";
                    }
                    else {
                        this.timecheck = this.timecheck.toString().substr(0, 4);

                    }
                }
                else {

                    if (this.timecheck.toString().length > 3) {
                        if (parseInt(this.timecheck.toString().substr(2, 2)) >= 60) {

                            this.timecheck = this.timecheck.toString().substr(0, 2) + "59";
                        }
                    }

                }
                return (this.timecheck);

            },
            setDisplayTime(val){
                let amount = val;
                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {

                    this.displaytimecheck = amount.toString().replace(/\B(?=(\d{2})+(?!\d))/g, ":");
                    if(parseInt(amount)<1000)
                    {
                        this.displaytimecheck = "0"+parseInt(amount).toString().replace(/\B(?=(\d{2})+(?!\d))/g, ":");
                    }
                } else {
                    this.displaytimecheck = amount;
                }
                return(this.displaytimecheck);
            },
            showstatussupplierinquiry(val) {
                let result="";
                if (val && this.inquirystatuslist) {

                    for (let res of this.inquirystatuslist) {
                        if (parseInt(val) === parseInt(res.value) || parseInt(val.inquiryStatus) === parseInt(res.value)) {
                            result = res.title;
                            break;
                        }

                    }
                }
                return(result);
            },
            showDateDayWork(val) {
                if (val) {
                    return (this.gregorianToJalaliBeautified(val, false));
                }
            },
            showExpiryHour(val){
                if (val) {
                    if (val.toString().length === 4) {
                        return (val.toString().substr(0, 2) + ":" + val.toString().substr(3, 2));
                    } else if (val.toString().length === 3) {
                        return (val.toString().substr(0, 2) + ":" + val.toString().substr(2, 1)+"0");

                    } else if (val.toString().length === 2) {
                        return (val.toString().substr(0, 2) + ":00");
                    }
                    else if (val.toString().length === 1) {
                        return ("0"+val.toString().substr(0, 1) + ":00");
                    }
                }
            },

            getcustomers() {
                new BaseService("customer", "/Getcustomer").getList().then(response => {
                    this.customers = response.data;
                }).catch(error => {
                    console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getcustomers2() {
                new BaseService("customer", "/Getcustomer").getList().then(response => {
                    this.customers2 = response.data;
                }).catch(error => {
                    console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getsuppliers() {
                new BaseService("Supplier", "/GetSupplier").getList().then(response => {

                    this.suppliers = response.data;
                }).catch(error => {
                    console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            createdailyReport() {


                this.hTo = this.dailyReportModel.toTime.toString().substr(11, 2);
                this.mTo = this.dailyReportModel.toTime.toString().substr(14, 2);
                this.totaltime = parseInt(this.hTo) * 60 + parseInt(this.mTo) + 1
                    - parseInt(this.hFrom) * 60 - parseInt(this.mFrom);
                this.dailyReportModel.totalWork = this.totaltime;
                this.dailyReportModel.day = this.jalaliToGregorian(this.dailyReportModel.day);
                this.dailyReportModel.fromTime = this.jalaliToGregorian(this.dailyReportModel.fromTime);
                this.dailyReportModel.toTime = this.jalaliToGregorian(this.dailyReportModel.toTime);
                this.dailyReportModel.titleWorkId = 4;
                if(this.dailyReportMode==="create")
                {
                    this.dailyReportModel.description = "ثبت استعلام قیمت - " + this.inquiriModel.customerFullName
                        +" از تامین کننده " +this.filtersupplier.fullName;
                }
                else {
                    this.dailyReportModel.description = "ویرایش استعلام قیمت - " +this.inquiriModel.customerFullName
                        +" از تامین کننده " +this.filtersupplier.fullName;
                }

                let rec = 0;
                for (let pr of this.productPriceInquiry) {
                    if(pr.productCount>0) {
                        rec++;
                        this.dailyReportModel.description = this.dailyReportModel.description + "  - " + pr.productName + " - " + pr.productCount;
                        if (rec > 3) break;
                    }
                }

                new BaseService("dailyReports", "/CreatedailyReports").create(this.dailyReportModel).then(response => {
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });

            },

            onAddSupplierInquiriClicked() {
                this.supplierInquiryList= {

                    Id: "",
                        supplierInquiryId: "",
                        inquiryId: "",
                        row: "",
                        supplierInquiryDate: "",
                        supplierInquiryHour: "",
                        customerId: "",
                        customerCode: "",
                        customerFullName: "",
                        nationalCode: "",
                        mobile: "",
                        shippingMethod: "",
                        invoiceType: "",
                        totalPrice: "",
                        totalPriceshow: "",
                        maximumValidityDate: "",
                        settlementPeriodWithSupplier: "",
                        sampleProduct: "",
                        sampleShipmentCode: "",
                        actionerId: "",
                        otherExplanations: "",
                        proformaInvoiceStatus: "",

                        status: "",

                };
                this.invoiceType ="";
                this.supplierInquiryDate="";
                this.maximumValidityDate="";
                this.filterinvoiceType="";
                this.filterenShippingMethod="";
                this.filtersupplier="";
                this.inquiriMode = "create";
                this.productarrayMode = "create";
                this.showinquiry = false;
                this.showsupplierinquiry = true;
                this.supplierInquiryList.inquiryId = this.inquiryId;
                for(let pr of this.productPriceInquiry) {
                    pr.buyPrice=0;
                    pr.totalPrice=0;
                    pr.discount=0;
                    pr.totalNetPrice=0;
                    pr.vat=0;
                    pr.totalVat=0;
                    pr.totalPriceVat=0;
                    pr.buyPriceshow=0;
                    pr.totalPriceshow=0;
                    pr.discountshow=0;
                    pr.totalNetPriceshow=0;
                    pr.vatshow=0;
                    pr.totalVatshow=0;
                    pr.totalPriceVatshow=0;
                }
                // this.sumbuyprice = 0;
                // this.sumtotalprice = 0;
                // this.sumdiscount = 0;
                // this.sumtotalnetprice = 0;
                // this.sumtotalvat = 0;
                // this.sumtotalpricevat = 0;
                // this.sumproductcount = 0;
                this.tbuyprice = 0;
                this.tdiscount = 0;
                this.ttotalPrice = 0;
                this.discount = 0;
                this.ttotalNetPrice = 0;
                this.ttotalVat = 0;
                this.ttotalPriceVat = 0;
                this.$refs.insertModal.showModal();


            },



            editInquiriItem(item) {

                this.dailyReportModel = {
                    id: 0,
                    description: "",
                    day: "",
                    fromTime: "",
                    toTime: "",
                    totalWork: "",
                    titleWorkId: "",
                    bossId: "",
                    bossApprovalDate: "",
                    managerId: "",
                    managerApprovalDate: "",
                    companyId: 0,
                    managerDescription :"",
                    bossDescription :"",
                    managerConfirm:0,
                    bossConfirm:0,
                };
                this.dailyReportMode="create";
                this.dateObj = new Date().toJSON();
                this.currentDate = this.gregorianToJalali(this.dateObj, false)
                this.dailyReportModel.day= Moment(this.currentDate).format('YYYY/MM/DD HH:mm');
                this.dailyReportModel.fromTime = Moment(this.currentDate).format('YYYY/MM/DD HH:mm');
                this.hFrom = this.dailyReportModel.fromTime.toString().substr(11,2);
                this.mFrom =  this.dailyReportModel.fromTime.toString().substr(14,2);


                this.inquiriModel = item;
                this.inquiryId = item.id;
                this.supplierinquiry = [];
                this.productarrayMode = "create";
                this.inquiriMode = "edit";
                for (let it of this.eninquiritype) {
                    if (it.value === item.inquiriType) {
                        this.selectedinquiritype = it.title;
                    }
                }

                this.filtercustomer = item.customerFullName;
                if (item.registrationDate != null) {
                    this.inquirydate = Moment(this.gregorianToJalali(item.registrationDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                }
                if (item.startDate != null) {
                    this.inquiryStartdate = Moment(this.gregorianToJalali(item.startDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                }
                if (item.expiryDate != null) {
                    this.inquiryEnddate = Moment(this.gregorianToJalali(item.expiryDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                }
                this.onChangestartHour();
                this.onChangeexpiryHour();
                this.getSupplierInquiryLists();
                new BaseService("InquiryProduct", `/GetInquiryProducts/${item.id}`).getList().then(response => {
                    this.productsInquiry = response.data;

                    if (this.productsInquiry.length > 0) {
                        let id = 0;
                        this.productPriceInquiry = [{

                        }];

                        this.sumproductcount = 0;

                        for (let pr of this.productsInquiry) {
                            this.productPriceInquiry.push({
                                id: id,
                                inquiryId: pr.inquiryId,
                                needSample: pr.needSample,
                                productId: pr.productId,
                                productName: pr.productName,
                                productCode: pr.productCode,
                                unitId: pr.unitId,
                                unitName: pr.unitName,
                                productCount: pr.productCount,
                                descriptionOnSite: pr.descriptionOnSite,
                                row: pr.row,
                                buyPrice: 0,
                                totalPrice: 0,
                                discount: 0,
                                totalNetPrice: 0,
                                vat: 0,
                                totalVat: 0,
                                totalPriceVat: 0,
                            });
                            this.sumproductcount = this.sumproductcount + pr.productCount;
                            id++;
                        }


                        this.isLoading = true;
                        this.$refs.insertModal.showModal();

                    }
                    else {
                        Utils.handleErrorWithNotification("هیچ کالایی برای این استعلام انتخاب نشده است. لطفا ابتدا کالاهای این استعلام را ثبت نمایید.", this.$noty);
                        this.isSending = false;
                        this.$refs.insertModal.hideModal();

                    }

                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });


            },
            getSupplierInquiryLists() {

                if (this.inquiryId) {
                    new BaseService("SupplierInquiry", `/GetSupplierInquiry/${this.inquiryId}`).getList().then(response => {
                        //if (response.data.length > 0) {

                            this.supplierinquiry = response.data;
                            for(let list of this.supplierinquiry){

                                this.getSupplierInquiryProducts(list.id);
                                break;
                            }
                        //}
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                }

            },

            editSupplierInquiryItem(item) {

                this.dailyReportModel = {
                    id: 0,
                    description: "",
                    day: "",
                    fromTime: "",
                    toTime: "",
                    totalWork: "",
                    titleWorkId: "",
                    bossId: "",
                    bossApprovalDate: "",
                    managerId: "",
                    managerApprovalDate: "",
                    companyId: 0,
                    managerDescription :"",
                    bossDescription :"",
                    managerConfirm:0,
                    bossConfirm:0,
                };
                this.inquiriMode="edit";
                this.supplierInquiryList = item;

                this.supplierInquiryDate = Moment(this.gregorianToJalali(item.supplierInquiryDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY')
                this.maximumValidityDate = Moment(this.gregorianToJalali(item.maximumValidityDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY')

                this.supplierInquiryHour = item.supplierInquiryHour;
                this.filtersupplier = item.customerFullName;


                for (let ship of this.enShippingMethod) {
                    if (item.shippingMethod === ship.value) {
                        this.filterenShippingMethod = ship.title;
                    }
                }

                for (let invoice of this.eninvoiceType) {
                    if (item.invoiceType === invoice.value) {
                        this.filterinvoiceType = invoice.title;
                    }
                }

                this.supplierInquiryList.inquiryId = this.inquiryId;
                let amount = this.supplierInquiryList.totalPrice;
                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    this.supplierInquiryList.totalPriceshow = (amount * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                this.inquiriMode = "edit";
                this.productarrayMode = "edit";
                this.showinquiry = false;
                this.showsupplierinquiry = true;

                this.getSupplierInquiryProducts(item.supplierInquiryId);
                this.$refs.insertModal.showModal();
            },

            getSupplierInquiryProducts(suplierId) {

                if (suplierId) {


                    new BaseService("SupplierInquiryProducts", `/GetSupplierInquiryProducts/${suplierId}`).getList().then(response => {

                        //  if (response.data.length > 0) {

                        this.supplierInquiryProducts = response.data;

                        this.sumbuyprice = 0;
                        this.sumtotalprice = 0;
                        this.sumdiscount = 0;
                        this.sumtotalnetprice = 0;
                        this.sumtotalvat = 0;
                        this.sumtotalpricevat = 0;
                        this.sumproductcount = 0;

                        for (let pr of this.supplierInquiryProducts) {

                            for (let prinq of this.productPriceInquiry) {

                                if (prinq.productId === pr.productId) {
                                    prinq.row = pr.row;
                                    prinq.buyPrice = pr.buyPrice;
                                    prinq.totalPrice = pr.totalPrice;
                                    prinq.discount = pr.discount;
                                    prinq.totalNetPrice = pr.totalNetPrice;
                                    prinq.vat = pr.vat;
                                    prinq.totalVat = pr.totalVat;
                                    prinq.totalPriceVat = pr.sumtotalpricevat;
                                    this.sumproductcount = this.sumproductcount + pr.productCount;
                                    this.thousandSeprator(prinq);
                                    break;
                                }
                            }

                            this.sumbuyprice = this.sumbuyprice + pr.buyPrice;
                            this.sumtotalprice = this.sumtotalprice + pr.totalPrice;
                            this.sumdiscount = this.sumdiscount + pr.discount;
                            this.sumtotalnetprice = this.sumtotalnetprice + pr.totalNetPrice;
                            this.sumtotalvat = this.sumtotalvat + pr.totalVat;
                            this.sumtotalpricevat = this.sumtotalpricevat + pr.totalPriceVat;
                            this.sumVat = this.sumtotalvat / this.sumtotalnetprice;
                        }
                        // this.sumVat = 0;
                        // if (this.sumtotalvat > 0) {
                        //     this.sumVat = this.sumtotalpricevat / this.sumtotalvat;
                        // }

                        // }
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                }
            },
            showDataOnTable(item){
                this.invoiceType = item .invoiceType;
                this.getSupplierInquiryProducts(item.supplierInquiryId);

            },
            deleteItem(item) {
                this.getSupplierInquiryProducts(item.supplierInquiryId);
                if (confirm("آیا از حذف این استعلام قیمت به همراه قیمت های پیشنهادی اطمینان دارید؟")) {

                    new BaseService("SupplierInquiryProducts", "DeleteSupplierInquiryProducts").delete(item.supplierInquiryId).then(response => {
                        Utils.handleErrorWithNotification("قیمت های پیشنهادی با موفقیت حذف شد", this.$noty);
                        new BaseService("SupplierInquiry", "DeleteSupplierInquirys").delete(item.supplierInquiryId).then(response => {
                            Utils.handleErrorWithNotification("این استعلام قیمت با موفقیت حذف شد", this.$noty);
                            this.getSupplierInquiryLists();
                            this.getSupplierInquiryProducts(item.supplierInquiryId);
                        }).catch(error => {
                            Utils.handleErrorWithNotification(error, this.$noty);
                        })
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error, this.$noty);
                    })
                }
            },






            cancelNewSupplierInquiry() {
                this.showinquiry = true;
                this.showsupplierinquiry = false;
                if (this.supplierinquiry.length > 0) {

                    this.getSupplierInquiryProducts(this.supplierinquiry[0]);
                } else {
                    for (let pr of this.productPriceInquiry) {
                        pr.buyPrice = 0;
                        pr.totalPrice = 0;
                        pr.discount = 0;
                        pr.totalNetPrice = 0;
                        pr.vat = 0;
                        pr.totalVat = 0;
                        pr.totalPriceVat = 0;
                        pr.vatshow = "";
                        pr.buyPriceshow = "";
                        pr.totalPriceshow = "";
                        pr.discountshow = "";
                        pr.totalNetPriceshow = "";
                        pr.totalVatshow = "";
                        pr.totalPriceVatshow = "";
                    }
                }
               // this.$refs.insertModal.hideModal();
            },


            onCreateInquiryDatePicked(val) {
                this.supplierInquiryDate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.supplierInquiryList.supplierInquiryDate = this.jalaliToGregorian(val);

            },
            onCreatemaximumValidityDatePicked(val) {
                this.maximumValidityDate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.supplierInquiryList.maximumValidityDate = this.jalaliToGregorian(val);
            },
            toggleCreateInquiryDatePicker() {
                this.$refs.supplierInquiryDate.togglePicker();
            },
            toggleCreatemaximumValidityDatePicker() {
                this.$refs.maximumValidityDate.togglePicker();
            },


            searching() {
                if (this.search.length >= 2) {
                    this.isLoading = false;
                    new BaseService("Inquiry", `/SearchInquirys/${this.search}`).getList().then(response => {
                        if (response.data.length > 0) {
                            this.inquirisList = response.data;
                            this.isLoading = true;
                        }
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                }
            }
            ,


            updatesupplierInSupplierInquiry() {
                this.isSending = true;
                this.showNewCustomer=false;
                this.showinquiry = false;
                this.showsupplierinquiry = true;



                new BaseService("supplier", "/Updatesupplier").update(this.supplierModel).then(response => {
                    this.$noty.success("تامین کننده با موفقیت ویرایش شد");
                    this.$refs.insertModal.hideModal();
                    this.getsuppliers();
                    this.isSending = false;
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                    this.getsuppliers();
                    this.isSending = false;
                });


            },
            createsupplierInSupplierInquiry() {
                this.isSending=true;

                if ((this.supplierModel.name + this.supplierModel.family) === null || this.supplierModel.family.length===0 ) {
                    Utils.handleErrorWithNotification("لطفا نام خانوادگی/نام شرکت تامین را وارد نمائید", this.$noty);
                    this.isSending = false;
                    return;
                }
                if(this.supplierModel.customerCode == null || this.supplierModel.customerCode.length===0){
                    Utils.handleErrorWithNotification("لطفا کد تامین را وارد نمائید", this.$noty);
                    this.isSending = false;
                    return;
                }

                this.showNewCustomer=false;
                this.showinquiry = false;
                this.showsupplierinquiry = true;


                new BaseService("supplier", "/Createsupplier").create(this.supplierModel).then(response => {
                    this.$noty.success("تامین کننده با موفقیت ثبت شد");
                    this.$refs.insertModal.showModal();
                    this.isSending = false;
                    this.getsuppliers();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.showModal();
                    this.isSending = false;
                    this.getsuppliers();
                });

            },
            cancelsupplierInSupplierInquiry() {
                this.isSending=false;
                this.showNewCustomer=false;
                this.showinquiry = false;
                this.showsupplierinquiry = true;
                this.$refs.insertModal.showModal();

            },



            newAddCustomer() {
                this.showNewCustomer = true;
                this.showinquiry = false;
                this.showsupplierinquiry = false;
                this.supplierModel = {
                    id: 0,
                    customerCode: "",
                    name: "",
                    family: "",
                    fullName: "",
                    fatherName: "",
                    mobile: "",
                    phone: "",
                    address: "",
                    postalCode: "",

                    email: "",
                    birthday: "",
                    nationalCode: "",
                    taxCode: "",
                    companeyId: 0,
                    customerType: 1,

                };
                this.supplierMode = "create";
                new BaseService("supplier", "/GetLastSupplierCode").getList().then(response => {
                    this.supplierModel.customerCode = response.data + 1;


                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
                this.$refs.insertModal.showModal();

            },
            onAddNewCustomerPhoneClicked()
            {
                if(this.supplierInquiryList.customerId===null || this.supplierInquiryList.customerId==='')
                {
                    Utils.handleErrorWithNotification("هیچ تامین کننده ای انتخاب نشده است. ابتدا یکی از تامین کنندگان راانتخاب کنید", this.$noty);
                 return;

                }
                this.showNewCustomerPhone=true;
                this.showNewCustomer = false;
                this.showinquiry = false;
                this.showsupplierinquiry = false;
                this.customerPhone= {
                    phoneNumber: "",
                    customerId: "",
                    customerPersonId: "",
                    description: "",
                    companyId: 0,
                    wareHouseId: "",

                    cellPhoneNumber: "",
                    customeremployeeFullName: "",
                    customerEmailAddress: "",
                    departmentName: "",
                    wareHouseAddress: "",
                    showName :""
                };
                this.customerPhoneModel = {
                    phoneNumber: "",
                    customerId: "",
                    customerPersonId: "",
                    description: "",
                    companyId: 0,
                    wareHouseId: "",

                    cellPhoneNumber: "",
                    customeremployeeFullName: "",
                    customerEmailAddress: "",
                    departmentName: "",
                    wareHouseAddress: ""
                };
                this.customerphoneMode = "create";
              this.getCustomerPhone();
                this.$refs.insertModal.showModal();

            },
            getCustomerPhone(){
                new BaseService("customerPhone", `/GetCustomerPhoneByCostumerId/${this.supplierInquiryList.customerId}`).getList().then(response => {
                    this.customerPhone = response.data ;
                    if(this.customerPhone.length>0){
                      for(let customer of this.customerPhone)
                      {
                          customer.showName =customer.departmentName +" - "+customer.customeremployeeFullName +" - "+customer.cellPhoneNumber;
                          this.tablecustomerphone.push(customer.showName);
                      }
                      this.filtercustomerphone = this.tablecustomerphone[0];
                    }

                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },

            updateCustomerPhone() {

                this.isSending = true;
                if ((this.customerModel.name + this.customerModel.family) === null || this.customerModel.family.length===0 ) {
                    Utils.handleErrorWithNotification("لطفا نام خانوادگی/نام شرکت مشتری را وارد نمائید", this.$noty);
                    this.isSending = false;
                    return;
                }
                if(this.customerModel.customerCode == null || this.customerModel.customerCode.length===0){
                    Utils.handleErrorWithNotification("لطفا کد مشتری را وارد نمائید", this.$noty);
                    this.isSending = false;
                    return;
                }

                new BaseService("CustomerPhone", "/UpdateCustomerPhone").update(this.customerPhoneModel).then(response => {
                    this.$noty.success("اطلاعات تماس تامین کننده با موفقیت ویرایش شد");
                    this.customerphoneMode="create";
                    this.customerPhoneModel = {
                        phoneNumber: "",
                        customerId: "",
                        customerPersonId: "",
                        description: "",
                        companyId: 0,
                        wareHouseId: "",

                        cellPhoneNumber: "",
                        customeremployeeFullName: "",
                        customerEmailAddress: "",
                        departmentName: "",
                        wareHouseAddress: "",
                    };
                    this.isSending=false;
                    this.getCustomerPhone();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);


                });



            },
            createCustomerPhone() {
                this.isSending=true;
                if ((this.customerPhoneModel.name + this.customerPhoneModel.family) === null ) {
                    Utils.handleErrorWithNotification("لطفا نام خانوادگی/نام شرکت مشتری را وارد نمائید", this.$noty);
                    this.isSending = false;
                    return;
                }
                if(this.customerPhoneModel.customerCode === null ) {
                    Utils.handleErrorWithNotification("لطفا کد مشتری را وارد نمائید", this.$noty);
                    this.isSending = false;
                    return;
                }
                this.showNewCustomer=false;
                this.showinquiry = false;
                this.showsupplierinquiry = true;
                this.$refs.insertModal.showModal();
                this.customerPhoneModel.customerId=this.supplierInquiryList.customerId;
                new BaseService("customerPhone", "/CreateCustomerPhone").create(this.customerPhoneModel).then(response => {
                    this.$noty.success("اطلاعات تماس تامین کننده با موفقیت ثبت شد");
                    this.customerPhoneModel = {
                        id :0,
                            phoneNumber: "",
                            customerId: "",
                            customerPersonId: "",
                            description: "",
                            companyId: 0,
                            wareHouseId: "",

                            cellPhoneNumber: "",
                            customeremployeeFullName: "",
                            customerEmailAddress: "",
                            departmentName: "",
                            wareHouseAddress: "",
                    };
                    this.isSending=false;
                    this.getCustomerPhone();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);

                });


            },
            cancelCustomerPhone() {
                this.isSending = false;
                this.showNewCustomer=false;
                this.showinquiry = false;
                this.showsupplierinquiry = true;
                this.showNewCustomerPhone=false;
                this.$refs.insertModal.showModal();

            },
            editPhoneItem(item){
                if(item) {
                    this.customerPhoneModel = {
                        phoneNumber: "",
                        customerId: "",
                        customerPersonId: "",
                        description: "",
                        companyId: 0,
                        wareHouseId: "",

                        cellPhoneNumber: "",
                        customeremployeeFullName: "",
                        customerEmailAddress: "",
                        departmentName: "",
                        wareHouseAddress: ""
                    };
                    this.customerPhoneModel.id = item.id;
                    this.customerPhoneModel.customerId = item.customerId;
                    this.customerPhoneModel.description=item.description;
                    this.customerPhoneModel.cellPhoneNumber=item.cellPhoneNumber;
                    this.customerPhoneModel.phoneNumber=item.phoneNumber;

                    this.customerPhoneModel.customeremployeeFullName=item.customeremployeeFullName;
                    this.customerPhoneModel.customerEmailAddress=item.customerEmailAddress;
                    this.customerPhoneModel.departmentName=item.departmentName;
                    this.customerPhoneModel.wareHouseAddress = item.wareHouseAddress;
                    this.customerphoneMode="edit";
                }
            },
            deletePhoneItem(item) {
                if(item) {
                    if (confirm("آیا از حذف این شماره تلفن اطمینان دارید؟")) {

                        new BaseService("CustomerPhone", "DeleteCustomerPhone").delete(item.id).then(response => {
                            Utils.handleErrorWithNotification("این شماره تلفن با موفقیت حذف شد", this.$noty);
                            this.getCustomerPhone();
                        }).catch(error => {
                            Utils.handleErrorWithNotification(error, this.$noty);
                        })
                    }
                }

            },
            thousandSeprator(a) {

                if (a) {
                    let amount = 0;
                    amount = a.buyPrice;
                    if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                        a.buyPrice = a.buyPrice * 1;
                        a.buyPriceshow = (amount * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        a.totalPrice = a.buyPrice * a.productCount;
                    }
                    a.totalPriceshow = a.totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                    amount = a.discount;
                    if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                        if (a.discount > 0) {
                            a.discount = a.discount * 1;
                            a.discountshow = (amount * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        }
                        a.totalNetPrice = a.totalPrice - a.discount;
                    }
                    a.totalNetPriceshow = a.totalNetPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    amount = a.vat;
                    if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                        if (parseInt(amount) > parseInt(this.maxvat)) {
                            a.vat = this.maxvat;
                        }
                        a.vat = a.vat * 1;
                        a.vatshow = a.vat / 100;
                        a.totalVat = a.totalNetPrice * a.vat / 100;

                        if (parseInt(a.vat) > 0 && ( (parseInt(this.supplierInquiryList.invoiceType) === 1 || this.supplierInquiryList.invoiceType === "" && this.invoiceType==="")
                                  || this.invoiceType===1)){
                            Utils.handleErrorWithNotification("فاکتور غیر رسمی است و یا نوع فاکتورانتخاب نشده است.لطفا پس از تغییر نوع فاکتور از غیر رسمی به فاکتور رسمی امتحان کنید", this.$noty);
                            a.vat = 0;
                            a.vatshow = "0";
                            a.totalVat = 0;
                            a.totalVatshow = "0";
                        }
                        if (parseInt(a.vat) > 0 && a.buyPrice === 0) {
                            Utils.handleErrorWithNotification("قیمت خرید وارد نشده است . لطفا ابتدا قیمت خرید را وارد نمایید و دوباره امتحان کنید", this.$noty);
                            a.vat = 0;
                            a.vatshow = "0";
                            a.totalVat = 0;
                            a.totalVatshow = "0";
                        }

                    }
                    a.totalVatshow = a.totalVat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                    a.totalPriceVat = a.totalNetPrice + a.totalVat;
                    a.totalPriceVatshow = a.totalPriceVat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    this.calcSumAmounts();

                }
            },
            calcSumAmounts() {

                this.tbuyprice = 0;
                this.tdiscount = 0;
                this.ttotalPrice = 0;
                this.discount = 0;
                this.ttotalNetPrice = 0;
                this.ttotalVat = 0;
                this.ttotalPriceVat = 0;
                for (let pr of this.productPriceInquiry) {

                    if (pr.productId >= 0) {
                        this.tbuyprice = this.tbuyprice + pr.buyPrice * 1;
                        this.tdiscount = this.tdiscount + pr.discount * 1;
                        this.ttotalPrice = this.ttotalPrice + pr.totalPrice * 1;
                        this.discount = this.discount + pr.discount * 1;
                        this.ttotalNetPrice = this.ttotalNetPrice + pr.totalNetPrice * 1;
                        this.ttotalVat = this.ttotalVat + pr.totalVat * 1;
                        this.ttotalPriceVat = this.ttotalPriceVat + pr.totalPriceVat * 1;
                    }
                }
                this.supplierInquiryList.totalPrice = this.ttotalNetPrice;
                this.supplierInquiryList.totalPriceshow = "";
                let amount = this.ttotalPriceVat;
                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    this.supplierInquiryList.totalPriceshow = (amount * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }


            },



            onfilterCustomerPhoneChange(val){
                if (val && val) {

                    this.filtercustomerphone = val;

                }
            },

            onfilterSupplierChange(val) {

                if (val && val.fullName) {

                    this.filtersupplier = val;
                    this.supplierInquiryList.customerId = val.id;
                    this.supplierInquiryList.customerFullName = val.fullName;
                    this.supplierInquiryList.mobile = val.mobile;
                    this.supplierInquiryList.nationalCode = val.nationalCode;
                    this.customerPhone =[{
                        phoneNumber: "",
                        customerId: "",
                        customerPersonId: "",
                        description: "",
                        companyId: 0,
                        wareHouseId: "",

                        cellPhoneNumber: "",
                        customeremployeeFullName: "",
                        customerEmailAddress: "",
                        departmentName: "",
                        wareHouseAddress: "",
                    }];
                        this.filtercustomerphone="";
                    this.tablecustomerphone =[];
                    this.getCustomerPhone();

                }
            },
            onfilterShippingMethodChange(val) {
                if (val && val.title != null) {
                    this.filterenShippingMethod = val.title;
                    this.supplierInquiryList.shippingMethod = val.value;

                }
            },
            onfilterInvoiceTypeChange(val) {

                if (val && val.title) {
                    this.filterinvoiceType = val.title;
                    this.supplierInquiryList.invoiceType = val.value;

                }
            },





        }
    }
</script>

<style lang="scss" scoped>
    .profile-image {
        margin: 0 auto 1rem auto;
    }

    .profile-image img {
        max-width: 150px;
        border-radius: 1rem;
        box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
    }
</style>